<div>
  <a-cascader
    v-model:value="innerValue"
    :options="options"
    :disabled="disabled"
    :change-on-select="changeOnSelect"
    :placeholder="placeholder"
    :field-names="{ label: 'name', value: 'id', children: 'children' }"
    :load-data="loadData"
    @change="onChange"
    :class="class"
  ></a-cascader>
</div>
